import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Switch from './Switch';

class SwitchExample extends Component {

  state = {
    label: 'This is a label',
  };

  onPropChange = e => this.setState(e.target.value);

  onChange = e => this.setState({ checked: e.target.value, indeterminate: false });

  render() {
    return (
      <Example {...this.props}>
        <Properties defaultProps={Switch.defaultProps} onChange={this.onPropChange} propTypes={Switch.propTypes} propValues={this.state}/>
        <div className="switches">
          <Switch {...this.state} onChange={this.onChange}/>
          <Switch {...this.state} className="primary" label="primary" onChange={this.onChange}/>
          <Switch {...this.state} className="secondary" label="secondary" onChange={this.onChange}/>
          <Switch {...this.state} className="secondary-selected-row" label="secondary in selected row" onChange={this.onChange}/>
        </div>
        <SourceCode querySelector=".core-switch"/>
      </Example>
    );
  }

}

SwitchExample.tags = 'toggle checkbox indeterminate';

export default SwitchExample;
